/**
 * @generated SignedSource<<51e13410f6d2fffd567f48835a43190b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingRatesControlInnerQuery$variables = {
  bookingId: string;
  duration?: number | null | undefined;
  groupSize?: number | null | undefined;
  membershipTypeId: string;
};
export type BookingRatesControlInnerQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetDurationBookingRateOptions_Booking">;
  } | null | undefined;
};
export type BookingRatesControlInnerQuery = {
  response: BookingRatesControlInnerQuery$data;
  variables: BookingRatesControlInnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bookingId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "duration"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupSize"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "bookingId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BookingRatesControlInnerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useGetDurationBookingRateOptions_Booking"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "BookingRatesControlInnerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "startSlot",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "highestPrecedentOnly",
                            "value": false
                          },
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CUSTOMER"
                          },
                          {
                            "kind": "Variable",
                            "name": "visibleToMembershipTypeId",
                            "variableName": "membershipTypeId"
                          }
                        ],
                        "concreteType": "SlotRate",
                        "kind": "LinkedField",
                        "name": "bookingRates",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "rate",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "visibility",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Variable",
                                    "name": "membershipTypeId",
                                    "variableName": "membershipTypeId"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "appliesToMembershipType",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "duration",
                                "variableName": "duration"
                              },
                              {
                                "kind": "Variable",
                                "name": "playerCount",
                                "variableName": "groupSize"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "totalDurationPrice",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TimeSlot",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Booking",
            "abstractKey": "__isBooking"
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "afe4bdf305114488a1914e813a4bb5b0",
    "id": null,
    "metadata": {},
    "name": "BookingRatesControlInnerQuery",
    "operationKind": "query",
    "text": "query BookingRatesControlInnerQuery(\n  $bookingId: ID!\n  $membershipTypeId: ID!\n  $duration: Int\n  $groupSize: Int\n) {\n  node(id: $bookingId) {\n    __typename\n    ...useGetDurationBookingRateOptions_Booking\n    id\n  }\n}\n\nfragment useGetDurationBookingRateOptions_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    id\n    ... on TimeSlot {\n      bookingRates(highestPrecedentOnly: false, type: CUSTOMER, visibleToMembershipTypeId: $membershipTypeId) {\n        rate {\n          __typename\n          id\n          name\n          visibility\n          appliesToMembershipType(membershipTypeId: $membershipTypeId)\n        }\n        totalDurationPrice(duration: $duration, playerCount: $groupSize)\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7aa32ee27745ec625cc9e27857f42795";

export default node;
